export * from './TabelaDePrecoServiceAdapter'